<template>
  <div class="complex-slider pb-16">
    <div class="overflow-hidden">
      <ul v-touch:swipe.left="goRight" v-touch:swipe.right="goLeft" :style="sliderStyle" class="w-full p-0 flex flex-nowrap transition transform duration-500" v-if="content.items">
        <li @click="activate(i)" class="cursor-pointer flex-1 overflow-hidden -mx-8" v-for="(item,  i) in content.items" :key="item._uid">
          <div :class="getClassesIfActive(i)" class="complex-slide rounded-xl overflow-hidden h-full scale-75 transform relative transition">
            <div :class="i === activeItem ? 'hidden' : ''" class="absolute inset-0 bg-black opacity-50"></div>
            <div class="w-full md:h-96 h-64 bg-no-repeat bg-cover bg-center grid place-items-center" :style="`backgroundImage:url(${item.img.filename})`">
              <a class="bg-primary hover:bg-primary-dark transition duration-300 text-white shadow-lg py-3 px-8 rounded-xl inline-block -mt-5" target="_blank" :href="item.link.url" v-if="item.link.url" v-html="item.link_text"></a>
            </div>
            <div class="-mt-24">
              <SmallWave />
              <div class="slide-content bg-gradient-to-r from-primary to-primary-light py-8 px-10 pt-0 md:-mt-8 -mt-3">
                <h3 class="block font-medium md:text-3xl text-xl text-white mb-4" v-html="item.title"></h3>
                <p class="block font-medium md:text-lg text-base text-gray-50" v-html="item.text"></p>
                <ul class="grid md:grid-cols-2 gap-3 grid-cols-1 mt-8 justify-items-start">
                  <li class="flex items-center gap-4">
                    <fai class="icon text-white md:text-4xl text-xl" icon="calendar"></fai>
                    <p class="text-white font-medium md:text-lg text-base" v-html="item.category"></p>
                  </li>
                  <li class="flex items-center gap-4">
                    <fai class="icon text-white md:text-4xl text-xl" icon="users"></fai>
                    <p class="text-white font-medium md:text-lg text-base" v-html="item.count"></p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </li>
      </ul>
      <ul class="flex mx-auto gap-4 mt-8">
        <li
          @click="activate(i)"
          :class="i === activeItem ? 'bg-primary' : ''"
          class="cursor-pointer hover:bg-primary bg-transparent transition w-5 h-5 border-2 border-primary border-solid rounded-full"
          v-for="(item, i) in content.items"
          :key="item._uid"
        ></li>
      </ul>
    </div>
  </div>
</template>

<script>
import SmallWave from "../SmallWave.vue";
export default {
  components: { SmallWave },
  data() {
    return {
      activeItem: 0,
    };
  },
  methods: {
    activate(i) {
      if (i !== this.activeItem) {
        this.activeItem = i;
      }
    },
    goRight() {
      this.content.items.length - 1 === this.activeItem
        ? (this.activeItem = 0)
        : this.activeItem++;
    },
    goLeft() {
      this.activeItem === 0
        ? (this.activeItem = this.content.items.length - 1)
        : this.activeItem--;
    },
    getClassesIfActive(i) {
      return i === this.activeItem ? "scale-100 opacity-100" : "";
    },
  },
  computed: {
    sliderStyle() {
      let transformValue =
        -((100 / this.content.items.length) * this.activeItem) +
        (1.428 / this.content.items.length) * 15;

      let widthValue =
        this.content.items.length * 100 - 30 * this.content.items.length;

      return {
        width: `${widthValue}%`,
        transform: `translateX(${transformValue}%)`,
      };
    },
  },
  props: {
    content: {
      type: Object,
      default: null,
    },
  },
};
</script>

<style lang="scss">
.complex-slide {
  box-shadow: 0 5px 10px rgba(154, 160, 185, 0.05),
    0 15px 40px rgba(166, 173, 201, 0.2);
  .slide-content {
    //clip-path: ellipse(100% 100% at 50% 100%);
  }
}
</style>